"use client"

import { memo } from "react"
import { Loader2, CheckCircle2 } from "lucide-react"

/* ── Thinking / 任务规划：完成态用青蓝专用容器；进行中用轻条不抢戏 ── */
export const ThinkingIndicator = memo(function ThinkingIndicator({ text, textAfter, allDone }: { text: string; textAfter?: string; allDone: boolean }) {
  const showAfter = allDone && textAfter
  if (showAfter) {
    return (
      <div
        className="agent-planning-panel animate-in fade-in duration-300 flex max-w-[85%] items-start gap-2.5 rounded-xl border px-3.5 py-2.5 shadow-sm"
      >
        <CheckCircle2 className="agent-planning-panel__icon mt-0.5 h-4 w-4 shrink-0" />
        <span className="agent-planning-panel__text text-sm font-medium leading-snug">
          {textAfter}
        </span>
      </div>
    )
  }
  return (
    <div className="animate-in fade-in duration-300 flex max-w-[85%] items-center gap-2 rounded-lg border border-border/50 bg-secondary/50 px-3 py-2">
      <Loader2 className="h-3.5 w-3.5 shrink-0 animate-spin text-primary" />
      <span className="text-sm text-muted-foreground">{text}</span>
    </div>
  )
})
